import useTranslatewrapper from "../../../components/useTranslateWrapper";

export default function useSampleDetailsSchema() {
    const {translate} = useTranslatewrapper();
  return {
    type: "object",
    properties: {
      testDate: {
        type: "string",
        format: "date",
        title: translate("testDate"),
      },
      performedBy: {
        type: "string",
        title: translate("performedBy"),
      },
      LabTest: {
        type: "string",
        title: "Lab tests",
      },
      GetAllFiles: {
        type: "string",
        title: "Upload Reports",
      },
    },
    required: ["testDate", "performedBy"],
  };
}
